// client/src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import CreateQRCode from './pages/CreateQRCode';
import Footer from './components/Footer';
import EditQRCode from './pages/EditQRCode';
import LandingPage from './pages/LandingPage';
import LinkShorts from './pages/LinkShorts';
import ProtectedRoute from './components/ProtectedRoute';
import CreateLinkShort from './pages/CreateLinkShort';
import EditLinkShort from './pages/EditLinkShort';
import BenefitsPage from './pages/BenefitsPage'; 
import Upgrade from './pages/Upgrade';
import AccountDeleted from './pages/AccountDeleted';
import ManageAccount from './pages/ManageAccount';
import { useAuth } from './hooks/useAuth';
import { useClerk } from '@clerk/clerk-react';
import { ensureUserInDatabase } from './utils/auth';
import TermsModal from './components/modals/termsModal';
import PrivacyModal from './components/modals/privacyModal';
import ScavengerHuntPage from './pages/ScavengerHuntPage';
import ArticlesList from './components/ArticlesList';
import ArticleDetail from './components/ArticleDetail';
// Import new bulk QR components
import BulkQRCreator from './pages/BulkQRCreator';
import EditBulkQRCodes from './pages/EditBulkQRCodes';
import Scanner from './pages/Scanner';
import QRcreator from './pages/marketing/QRcreator';
import AIscanner from './pages/marketing/AIscanner';
import { GoogleOneTap } from '@clerk/clerk-react';

// Create redirect components that use window.location
function RedirectToClerkSignIn() {

  useEffect(() => {
      window.location.href = "https://accounts.boxyqr.com/sign-in?redirect_url=https://app.boxyqr.com/create";
      // window.location.href = "https://creative-kodiak-14.accounts.dev/sign-in"; 
  }, []);
  return <GoogleOneTap />;
  
}

function RedirectToClerkSignUp() {
  useEffect(() => {
    window.location.href = "https://accounts.boxyqr.com/sign-up?redirect_url=https://app.boxyqr.com/create";
    // window.location.href = "https://creative-kodiak-14.accounts.dev/sign-up";
  }, []);
  return <GoogleOneTap />;
}

function App() {
  const { session } = useClerk();
  const { user, isSignedIn, isLoaded } = useAuth();

  useEffect(() => {
    if (session) {
      // When session changes (user logs in), ensure they exist in database
      ensureUserInDatabase();
    }
  }, [session]);

  return (
    <Router>
      <div className="flex flex-col">
        <Navbar />
        <main className="bg-gray-100 min-w-screen min-h-screen px-3 pb-20">
          <Routes>         
            <Route path="/" element={<LandingPage />} />
            <Route path="/benefits" element={<BenefitsPage />} />
            <Route path="/hunt" element={<ScavengerHuntPage />} />
            <Route path="/articles" element={<ArticlesList />} />
            <Route path="/articles/:slug" element={<ArticleDetail />} />
            <Route path="/QRcreator" element={<QRcreator />} />
            <Route path="/AIscanner" element={<AIscanner />} />

            <Route path="/terms" element={<TermsModal />} />
            <Route path="/privacy" element={<PrivacyModal />} />
            
            {/* Use the redirect components for auth routes */}
            <Route path="/sign-in/*" element={<RedirectToClerkSignIn />} />
            <Route path="/sign-up/*" element={<RedirectToClerkSignUp />} />
            
            {/* Protected app routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/upgrade" element={
              <ProtectedRoute>
                <Upgrade />
              </ProtectedRoute>
            } />
            <Route path="/create" element={
              <ProtectedRoute>
                <CreateQRCode />
              </ProtectedRoute>
            } />
            <Route path="/create-link" element={
              <ProtectedRoute>
                <CreateLinkShort />
              </ProtectedRoute>
            } />
            <Route path="/edit/:id" element={
              <ProtectedRoute>
                <EditQRCode />
              </ProtectedRoute>
            } />
            <Route path="/edit-link/:id" element={
              <ProtectedRoute>
                <EditLinkShort />
              </ProtectedRoute>
            } />
                        <Route path="/bulk-edit/:id" element={
              <ProtectedRoute>
                <EditBulkQRCodes />
              </ProtectedRoute>
            } />
            <Route path="/account-deleted" element={
              <ProtectedRoute>
                <AccountDeleted />
              </ProtectedRoute>
            } />
            <Route path="/manage-account" element={
              <ProtectedRoute>
                <ManageAccount />
              </ProtectedRoute>
            } />
              <Route path="/scanner" element={
              <ProtectedRoute>
                <Scanner />
              </ProtectedRoute>
            } />
            {/* New Bulk QR routes */}
            <Route path="/bulk-upload" element={
              <ProtectedRoute>
                <BulkQRCreator />
              </ProtectedRoute>
            } />
            <Route path="/edit-bulk/:id" element={
              <ProtectedRoute>
                <EditBulkQRCodes />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
        <Footer />
        <TermsModal />
        <PrivacyModal />
      </div>
    </Router>
  );
}

export default App;
//WORKING
// // client/src/App.js
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Dashboard from './pages/Dashboard';
// import CreateQRCode from './pages/CreateQRCode';
// import Footer from './components/Footer';
// import EditQRCode from './pages/EditQRCode';
// import LandingPage from './pages/LandingPage';
// import { SignIn, SignUp } from '@clerk/clerk-react';




// function App() {
//   return (
//     <Router>
//       <div className="flex flex-col min-h-screen">
//         <Navbar />
//         <main className="flex-grow container mx-auto px-4 py-6">
//           <Routes>         
//           <Route path="/" element={<LandingPage />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/create" element={<CreateQRCode />} />
//           <Route path="/edit/:id" element={<EditQRCode />} />
//           <Route path="/landing" element={<LandingPage />} />

//           </Routes>
//         </main>
//         <Footer />
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { QueryClient, QueryClientProvider } from 'react-query';
// import { ClerkProvider } from '@clerk/clerk-react';

// // Import components
// import Navbar from './components/Navbar';
// import LandingPage from './pages/LandingPage';

// // Placeholder Footer
// const Footer = () => (
//   <footer className="bg-gray-100 p-4 text-center">
//     © {new Date().getFullYear()} BoxyQR
//   </footer>
// );

// // Create a query client
// const queryClient = new QueryClient();

// // Clerk Publishable Key
// const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// function App() {
//   return (
//     <ClerkProvider publishableKey={clerkPubKey}>
//       <QueryClientProvider client={queryClient}>
//         <Router>
//           <div className="flex flex-col min-h-screen">
//             <Navbar />
            
//             <main className="flex-grow container mx-auto px-4 py-6">
//               <Routes>
//                 <Route 
//                   path="/" 
//                   element={<LandingPage />}
//                 />
//               </Routes>
//             </main>
            
//             <Footer />
//           </div>
//         </Router>
//       </QueryClientProvider>
//     </ClerkProvider>
//   );
// }

// export default App;

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import { QueryClient, QueryClientProvider } from 'react-query';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// // Components and Pages
// import Navbar from './components/Navbar';
// import Dashboard from './pages/Dashboard';
// import CreateQRCode from './pages/CreateQRCode';
// import ViewQRCode from './pages/ViewQRCode';
// import Footer from './components/Footer';
// import LandingPage from './pages/LandingPage';
// import Settings from './pages/Settings';
// import Analytics from './pages/Analytics';

// // QR Redirect component
// function QRRedirect() {
//   const { shortId } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     const handleRedirect = async () => {
//       try {
//         const response = await axios.get(`/api/qrcodes/redirect/${shortId}`);
        
//         // If we get a URL, redirect to it
//         if (response.data.redirectUrl) {
//           window.location.href = response.data.redirectUrl;
//         } else {
//           setError('Invalid QR code');
//           setLoading(false);
//         }
//       } catch (err) {
//         setError('This QR code is not available or has expired');
//         setLoading(false);
//       }
//     };

//     handleRedirect();
//   }, [shortId]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-center">
//           <svg className="animate-spin h-10 w-10 text-blue-500 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//           </svg>
//           <p className="text-lg">Redirecting...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-center max-w-md p-6 bg-white rounded-lg shadow-md">
//           <div className="text-red-500 text-5xl mb-4">
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-16 w-16 mx-auto">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//             </svg>
//           </div>
//           <h2 className="text-2xl font-bold mb-2">QR Code Error</h2>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <a href="/" className="inline-block bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200">
//             Go to BoxyQR
//           </a>
//         </div>
//       </div>
//     );
//   }

//   return null;
// }

// // Create a client for React Query
// const queryClient = new QueryClient();

// function App() {
//   return (
//     <QueryClientProvider client={queryClient}>
//       <Router>
//         <div className="flex flex-col min-h-screen">
//           <Navbar />
//           <main className="flex-grow container mx-auto px-4 py-6">
//             <Routes>
//               {/* Public routes */}
//               <Route path="/" element={<LandingPage />} />
//               <Route path="/redirect/:shortId" element={<QRRedirect />} />
              
//               {/* Directly rendered routes */}
//               <Route path="/dashboard" element={<Dashboard />} />
//               <Route path="/create" element={<CreateQRCode />} />
//               <Route path="/qrcode/:id" element={<ViewQRCode />} />
//               <Route path="/settings" element={<Settings />} />
//               <Route path="/analytics" element={<Analytics />} />
//             </Routes>
//           </main>
//           <Footer />
//         </div>
//       </Router>
//     </QueryClientProvider>
//   );
// }

// export default App;
// // App.js - Main Application with Clerk Integration

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import Settings from './pages/Settings';
// import Analytics from './pages/Analytics';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { ClerkProvider } from '@clerk/clerk-react';

// import { QueryClient, QueryClientProvider } from 'react-query';

// import Navbar from './components/Navbar';
// import Dashboard from './pages/Dashboard';
// import CreateQRCode from './pages/CreateQRCode';
// import ViewQRCode from './pages/ViewQRCode';
// import Footer from './components/Footer';
// import LandingPage from './pages/LandingPage';
// import Settings from './pages/Settings';
// import Analytics from './pages/Analytics';
// import QRRedirect from './components/QRRedirect';  // Assuming you moved QRRedirect to its own component

// // Create a client for React Query
// const queryClient = new QueryClient();

// // Clerk publishable key
// const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// // Create a client for React Query
// const queryClient = new QueryClient();

// function App() {
//   return (
//     <ClerkProvider publishableKey={clerkPubKey}>
//       <QueryClientProvider client={queryClient}>
//         <Router>
//           <div className="flex flex-col min-h-screen">
//             <Navbar />
//             <main className="flex-grow container mx-auto px-4 py-6">
//               <Routes>
//                 {/* Public routes */}
//                 <Route path="/" element={<LandingPage />} />
//                 <Route path="/redirect/:shortId" element={<QRRedirect />} />
                
//                 {/* Protected routes */}
//                 <Route 
//                   path="/dashboard" 
//                   element={
//                     <ProtectedRoute>
//                       <Dashboard />
//                     </ProtectedRoute>
//                   } 
//                 />
//                 <Route 
//                   path="/create" 
//                   element={
//                     <ProtectedRoute>
//                       <CreateQRCode />
//                     </ProtectedRoute>
//                   } 
//                 />
//                 <Route 
//                   path="/qrcode/:id" 
//                   element={
//                     <ProtectedRoute>
//                       <ViewQRCode />
//                     </ProtectedRoute>
//                   } 
//                 />
//                 <Route 
//                   path="/settings" 
//                   element={
//                     <ProtectedRoute>
//                       <Settings />
//                     </ProtectedRoute>
//                   } 
//                 />
//                 <Route 
//                   path="/analytics" 
//                   element={
//                     <ProtectedRoute>
//                       <Analytics />
//                     </ProtectedRoute>
//                   } 
//                 />
//               </Routes>
//             </main>
//             <Footer />
//           </div>
//         </Router>
//       </QueryClientProvider>
//     </ClerkProvider>
//   );
// }

// // QR Redirect component for handling redirects via shortId
// function QRRedirect() {
//   const { shortId } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     const handleRedirect = async () => {
//       try {
//         const response = await axios.get(`/api/qrcodes/redirect/${shortId}`);
        
//         // If we get a URL, redirect to it
//         if (response.data.redirectUrl) {
//           window.location.href = response.data.redirectUrl;
//         } else {
//           setError('Invalid QR code');
//           setLoading(false);
//         }
//       } catch (err) {
//         setError('This QR code is not available or has expired');
//         setLoading(false);
//       }
//     };

//     handleRedirect();
//   }, [shortId]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-center">
//           <svg className="animate-spin h-10 w-10 text-blue-500 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//           </svg>
//           <p className="text-lg">Redirecting...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-screen">
//         <div className="text-center max-w-md p-6 bg-white rounded-lg shadow-md">
//           <div className="text-red-500 text-5xl mb-4">
//             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-16 w-16 mx-auto">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//             </svg>
//           </div>
//           <h2 className="text-2xl font-bold mb-2">QR Code Error</h2>
//           <p className="text-gray-600 mb-4">{error}</p>
//           <a href="/" className="inline-block bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-200">
//             Go to BoxyQR
//           </a>
//         </div>
//       </div>
//     );
//   }
  
// }

// export default App;



// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// function App() {
//   return (
//     <Router>
//       <div style={{backgroundColor: 'green', color: 'white', padding: '20px'}}>
//         <h1>BoxyQR App Loaded</h1>
//         <Routes>
//           <Route 
//             path="/" 
//             element={<div>Landing Page Placeholder</div>} 
//           />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;


// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { QueryClient, QueryClientProvider } from 'react-query';

// // Import components one by one
// import Navbar from './components/Navbar';
// import LandingPage from './pages/LandingPage';
// import Footer from './components/Footer';

// // Create a query client
// const queryClient = new QueryClient();

// function App() {
//   return (
//     <QueryClientProvider client={queryClient}>
//       <Router>
//         <div style={{backgroundColor: 'green', color: 'white', padding: '20px'}}>
//           <h1>BoxyQR App Loaded</h1>
          
//           {/* Try rendering Navbar */}
//           <div style={{backgroundColor: 'blue', color: 'white', padding: '10px'}}>
//             Navbar Placeholder
//             {/* Uncomment when ready: <Navbar /> */}
//           </div>

//           <Routes>
//             <Route 
//               path="/" 
//               element={
//                 <div style={{backgroundColor: 'purple', color: 'white', padding: '10px'}}>
//                   Landing Page Placeholder
//                   {/* Uncomment when ready: <LandingPage /> */}
//                 </div>
//               } 
//             />
//           </Routes>

//           {/* Try rendering Footer */}
//           <div style={{backgroundColor: 'red', color: 'white', padding: '10px'}}>
//             Footer Placeholder
//             {/* Uncomment when ready: <Footer /> */}
//           </div>
//         </div>
//       </Router>
//     </QueryClientProvider>
//   );
// }

// export default App;